import { useDeepCompareEffect, useFirstMountState } from 'react-use';

import { MedicalServiceFormController } from '../form/medicalServiceForm.types';

import { updatePractitionerWithDefaultConfiguration } from './practitioner.utils';

type usePractitionerSynchronizationOptions = Pick<
   MedicalServiceFormController,
   'watch' | 'getValue' | 'control' | 'setValue' | 'trigger'
>;

export const usePractitionersSynchronization = ({
   getValue,
   control,
   setValue,
   watch,
}: usePractitionerSynchronizationOptions): void => {
   const firstMount = useFirstMountState();
   const { settlementType, defaultPrice, fixedValue, proportionalValue, taxRate } = watch([
      'settlementType',
      'defaultPrice',
      'fixedValue',
      'proportionalValue',
      'taxRate',
   ]);

   return useDeepCompareEffect(() => {
      const practitioners = getValue('practitioners');
      if (!firstMount && practitioners) {
         const updatedPractitioners = practitioners.map(
            updatePractitionerWithDefaultConfiguration(control.getValues())
         );
         setValue('practitioners', updatedPractitioners);
      }
   }, [settlementType, defaultPrice, fixedValue, proportionalValue, taxRate]);
};
